module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 47
// module chunks = 0